import http from './httpService';
/*global API */

const simulatorEndpoint = `${API}/api/Simulator`;
const jobsEndpoint = `${API}/api/Jobs`;

export function createCompetences(numCompetences) {
  return http.post(simulatorEndpoint, { num: numCompetences });
}

export function createJobs(numJobs) {
  return http.post(simulatorEndpoint + '/CreateJobs', { num: numJobs });
}

export function createJob(jobTmp) {
  return http.post(simulatorEndpoint + '/CreateJob', jobTmp);
}

export function getJobsForSelect(searchString) {
  return http.get(jobsEndpoint + '/jobsForSelect', {
    params: {
      searchString: searchString,
    },
  });
}

export function removeNewApplicantStatuses() {
  return http.post(simulatorEndpoint + '/RemoveNewApplicantStatuses');
}

export function removeNewApplicationStatuses() {
  return http.post(simulatorEndpoint + '/RemoveNewApplicationStatuses');
}

export function RemoveTenantsWithNoJobs() {
  return http.post(simulatorEndpoint + '/RemoveTenantsWithNoJobs');
}

export function addApplicantsToAJob(jobId, numApplicants) {
  return http.post(simulatorEndpoint + '/AddApplicantsToAJob', { jobId, numApplicants });
}

export function AddApplicantsToRandomJobs(num) {
  return http.post(simulatorEndpoint + '/AddApplicantsToRandomJobs', { num });
}

export function CreateJsonCopyOfCompetences(locationToSave) {
  return http.post(simulatorEndpoint + '/CreateJsonCopyOfCompetences', { locationToSave });
}

export function uploadFileToAzure() {
  return http.post(simulatorEndpoint + '/uploadFileToAzure');
}

export function fixNonAssignedApplicants() {
  return http.post(simulatorEndpoint + '/fixNonAssignedApplicants');
}

export function downloadFileFromAzure() {
  return http.post(simulatorEndpoint + '/downloadFileFromAzure');
}

export function sendEmail() {
  return http.post(simulatorEndpoint + '/sendEmail');
}

